<template>
  <RolePermissionForm :isCreate="true"></RolePermissionForm>
</template>
<script>
import RolePermissionForm from "@/views/components/role-permission/RolePermissionForm.vue";

export default {
  name: "RolePermissionNew",
  components: {
    RolePermissionForm,
  },
  data: () => ({}),
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style></style>
